module.exports = __webpack_public_path__ + "dbef3bd9d57cad029f2954cc8e3cf103.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-5.png
// module id = 3126
// module chunks = 0